module.exports = __webpack_public_path__ + "static/media/MRA_PIC1.e493ed59.jpeg";